function getInfo(
  data: {
    key: string;
    label: React.ReactNode | string;
  }[],
  key: string,
) {
  return data.find((item) => item.key === key);
}
export function getFractionStructure(
  allKeys: string[],
  selectedNumerator: string,
  data: {
    key: string;
    label: React.ReactNode | string;
  }[],
) {
  const numerator = getInfo(data, selectedNumerator);
  const denominators = allKeys.filter((k) => k !== selectedNumerator).map((k) => getInfo(data, k));

  return { numerator, denominators };
}
